import type { MemberLevel } from '@/constants/account'
import type { MemberInfo } from './account'

export interface SellInfo {
  id: MemberLevel
  code: MemberCode
  sellType: number
  name: string
  amount: number
  subscriptAmount: number
  desc: string
  metadata?: {
    period_unit?: 'month' | 'year'
  }
  ext?: {
    client_id: string
    plan_id: string
  }
}

export interface PayInfo {
  userId: number
  status: number
  memberId: number
  bill: {
    payUrl: string
    status: 0
  }
  payAmount: number
}

export enum MemberCode {
  nonMember = 'non-member',
  free = 'free',
  trial = 'trial',
  personal = 'personal',
  starter = 'starter',
  professional = 'professional',
  plus = 'plus',
  pro = 'pro',
  enterprise = 'enterprise',
  enterpriseCustomized = 'enterprise-customized'
}

export enum StripeStatus {
  CREATED = 'created',
  SUBSCRIBED = 'subscribed',
  CONFIRMED = 'confirmed',
  PAYMENT_CHECK_FAIL = 'payment_check_fail'
}

export interface CheckResult {
  id: number
  payment_subscription_id: string
  uniq_id: string
  payment_source: string
  status: StripeStatus
  subscription_time: number
  create_time: number
}

export interface StripeUpgradeBillingData {
  nextAction: {
    action: string
    url: string
    sessionId: string
  } | null
  userMember: MemberInfo
}

export enum StripeSubscribeStatus {
  /**
   * 激活
   */
  ACTIVE = 2,
  /**
   * 暂停
   */
  PAUSED = 3,
  /**
   * 取消
   */
  CANCELLED = 4,
}

export enum StripeInvoiceStatus {
  /**
   * 已支付
   */
  PAID = 'paid',
  /**
   * 未支付
   */
  UNPAID = 'unpaid',
  /**
   * 已关闭
   */
  CLOSE = 'close',
}

export interface StripeSubscribeStatusInfo {
  subscription_id: string
  status: StripeSubscribeStatus
  expire_time: number
  last_invoice?: {
    status: StripeInvoiceStatus
    create_time: number
    url: string
  }
}
